import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-heart",
  "use": "icon-heart-usage",
  "viewBox": "0 0 21 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 17\" id=\"icon-heart\">\r\n    <path fill=\"#EF6263\" fill-rule=\"evenodd\" d=\"M10.6 17c8.326-5.535 11.423-10.235 9.294-14.1-2.13-3.866-5.228-3.866-9.294 0m0 14.1C2.274 11.465-.823 6.765 1.306 2.9c2.13-3.866 5.228-3.866 9.294 0\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol